import { Container, LoadingStyle } from './Loading.style'

type LoadingProps = {
  contrast: boolean
}

export function Loading({ contrast }: LoadingProps) {
  return (
    <Container>
      <LoadingStyle constrast={contrast}>
        <div />
        <div />
        <div />
      </LoadingStyle>
    </Container>
  )
}
